import { useContext, useState } from 'react';
import { AttachMoney } from '@mui/icons-material';
import { Button, CircularProgress, Typography } from '@mui/material';
import { Box, FormControl, FormLabel, InputAdornment } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
// Our Components
import { CardContext } from 'context/cards/cardContext';
// Utils and Helpers
import { numberFormat } from 'helpers/i18n';
// assets
import './EditCardFundsForm.css';

const isValidFundingAmount = (limitAmount, availableLimit) => {
    if (Number(limitAmount) > Number(availableLimit)) {
        return false;
    }
    return true;
};

const EditCardFundsForm = ({ onSubmit }) => {
    const { card, statistics } = useContext(CardContext);
    const [didFormValuesChange, setDidFormValuesChange] = useState(false);
    const [hasClickAddFunds, setHasClickedAddFunds] = useState(false);

    const addFundsSchema = Yup.object().shape({
        fundingAmount: Yup.number()
            .typeError('Invalid amount')
            .positive('Invalid amount')
            .required('Required')
            .test('isValidIncreaseLimitAmount', 'Insufficient funds to create this card', fundingAmount =>
                isValidFundingAmount(fundingAmount, statistics.availableToAddtoCards)
            )
    });

    return (
        <Box marginBottom="24px">
            <Formik
                initialValues={{
                    balance: card.balance,
                    fundingAmount: 0
                }}
                enableReinitialize={true}
                validationSchema={addFundsSchema}
                onSubmit={onSubmit}>
                {({ dirty, values, isSubmitting }) => (
                    <Form id="edit-card-funds-form">
                        {setDidFormValuesChange(dirty)}
                        <Box>
                            <FormLabel className="edit-card-funds__card-input-label">Card Balance</FormLabel>
                            <Typography className="edit-card-funds__card-balance">
                                {numberFormat(values.balance || 0, 2, 2)}
                            </Typography>
                        </Box>
                        {hasClickAddFunds ? (
                            <Box display="flex">
                                <FormControl fullWidth sx={{ marginRight: '10px' }}>
                                    <Field
                                        component={TextField}
                                        variant="outlined"
                                        name="fundingAmount"
                                        type="text"
                                        size="small"
                                        helperText={
                                            <Box>
                                                Available to add to card:
                                                <Box component="label" sx={{ color: 'var(--main-color)', fontWeight: 'bold' }}>
                                                    {' '}
                                                    {numberFormat(statistics.availableToAddtoCards, 2, 2)}
                                                </Box>
                                            </Box>
                                        }
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <AttachMoney sx={{ color: values?.id ? '#909DA6' : 'black' }} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                                <Button
                                    variant="outlined"
                                    type="submit"
                                    form="edit-card-funds-form"
                                    disabled={isSubmitting || !didFormValuesChange}>
                                    {isSubmitting ? <CircularProgress size="20px" /> : 'Add'}
                                </Button>
                            </Box>
                        ) : (
                            <Button variant="outlined" onClick={() => setHasClickedAddFunds(true)} marginBottom="24px">
                                Add Funds
                            </Button>
                        )}
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default EditCardFundsForm;
